export default __webpack_public_path__ + "static/media/icsan.ea17b83c.png";